import dxStatus from '../dxStatusCodes'
// import DxCompanyRole from './DxCompanyRole'
// import DxCompanyType from './DxCompanyType'

export class DxCompanyData {
    static validate(company) {
        let required = ['companyName',
            'companyAddress1', 'companyCity','companyState','companyZip',
            'companyNAICS']
    
        let missing = ''
        required.forEach((value) => {
            let v = company[value]
            if (v === undefined || v === null || v === '') {
                missing += value + " "
            }
        })
        if (missing !== '') {
            dxStatus.throwInvalidData("Missing: " + missing)
        }

        // TODO: When implementing checks
        // if (! DxCompanyType.isValid(company.companyType) ) {
        //     dxStatus.throwInvalidData("companyType: " +  company.companyType)
        // }

        // if (! DxCompanyRole.isValid(company.companyRole) ) {
        //     dxStatus.throwInvalidData("companyRole: " + company.companyRole)
        // }
        return true
    }

    static compare(lhs, rhs) {
        let lhsLength = Object.keys(lhs).length
        let rhsLength = Object.keys(rhs).length
        if (lhsLength !== rhsLength) {
            return false;
        }
        for (let x in lhs) {
            if (lhs[x] !== rhs[x]) {
                return false
            }
        }
        return true
    }
}

export default DxCompanyData